import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ActionService } from 'src/app/core/services/action.service';
import { RouteService } from 'src/app/core/services/route.service';
import { BulkUpdateClient } from 'src/app/core/state/_actions/clients.actions';
import { LoadForms } from 'src/app/core/state/_actions/form.actions';
import { BulkUpdateNotifications } from 'src/app/core/state/_actions/notification.actions';
import { BulkUpdateProcess, LoadProcesss } from 'src/app/core/state/_actions/process.actions';
import { BulkUpdateReports, LoadReports } from 'src/app/core/state/_actions/report.actions';
import { LoadRoles } from 'src/app/core/state/_actions/settings/roles.actions';
import { BulkUpdateUsers } from 'src/app/core/state/_actions/user.actions';
import { OpTypes } from 'src/app/core/state/_models/general.model';
import * as moment from 'moment';
import { getClientsOperations } from 'src/app/core/state/_selectors/clients.selector';
import { getForms, getFormsLoading } from 'src/app/core/state/_selectors/form.selector';
import { getNotificationOperations } from 'src/app/core/state/_selectors/notification.selector';
import { getProcesses,getProcessesLoading, getProcessOperations } from 'src/app/core/state/_selectors/process.selector';
import { getReportOperations, getReports } from 'src/app/core/state/_selectors/report.selector';
import { getAllRoles } from 'src/app/core/state/_selectors/settings/roles.selector';
import { getUserOperations } from 'src/app/core/state/_selectors/user.selector';
import { timeOptions } from 'src/app/modules/application/notification/notification.constants';
import { alertPresets, AlertService } from 'src/app/shared/services/alert.service';
import { SweetAlertOptions } from 'sweetalert2';
import { DROPDOWN_VALUE_PLACEHOLDER } from 'src/app/shared/constants';
import { SubSink } from 'subsink';
@Component({
  selector: 'app-datatable-bulk-edit',
  templateUrl: './datatable-bulk-edit.component.html',
  styleUrls: ['./datatable-bulk-edit.component.scss']
})
export class DatatableBulkEditComponent implements OnInit {
  @Input('selectedItems') selectedItems: Array<any> = [''];
  @Input('columns') columns: Array<any> = [''];
  @Input('modalLayer') modalLayer: number = 0;
  @Input('tableId') tableId: any = '';
  @Input('datatableTableName') datatableTableName: string | null = null;
  @Input('isExternalOptions') isExternalOptions: boolean  = false;

  @ViewChild('input', { static: false }) input!: any;
  @ViewChild('select', { static: false }) select!: any;
  @ViewChild('checkbox', { static: false }) checkbox!: any;
  @ViewChild('textarea', { static: false }) textarea!: any;
  @ViewChild('updateActiveTemplate', { static: false }) updateActiveTemplate!: any;
  form!:UntypedFormGroup;
  multiple_values = 'Multiple Values';
  options:any = null;
  formOptions:any = null;
  processOptions:any = null;
  roleOptions:any = null;
  activeColumn = { Name: 'Active', FieldName:'active', IsBulkUpdateAllowed:true, FieldType: 'TINYINT(1)',formFieldKey:'Active'};
  buttonText:string = ''
  userModalRef:any;
  reportTypes = [
    {label:'CSV',value:0},
    {label:'Excel',value:1},
    {label:'PDF',value:2},
  ]
  additionalSubscriptionColumns = [
    { Name: 'Include Link', FieldName:'include_link', FieldType:'TINYINT(1)', ConditionalBulkUpdate:true, formFieldKey:'IncludeLink', },
    { Name: 'Report Format', FieldName:'report_format', FieldType:'ENUM', ConditionalBulkUpdate:true, formFieldKey:'ReportFormat', },
  ]
  weekDays = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];
  fieldObj:any = {};

  subscriptionDaysArray!:UntypedFormArray;
  DROPDOWN_VALUE_PLACEHOLDER = DROPDOWN_VALUE_PLACEHOLDER;
  isFormsLoading:{[key:string]:boolean}={};
  isProcessesLoading:{[key:string]:boolean}={};
  subsink: SubSink = new SubSink();

  constructor(
    private modal: NgbModal,
    private fb:UntypedFormBuilder,
    private store:Store,
    private route: RouteService,
    private cd:ChangeDetectorRef,
    private action:ActionService,
    private alert:AlertService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      FieldsList:this.fb.array([])
    });
    this.getApiState();
    this.subscriptionDaysArray = this.fb.array([]);
    if(this.datatableTableName === 'Notifications' || 
      this.datatableTableName === 'Subscriptions' || 
      this.datatableTableName === 'Workflows' || 
      this.datatableTableName === 'Processes'
    ){
      this.columns.push(this.activeColumn);
    }
    if(this.datatableTableName === 'Subscriptions'){
      this.columns.push(...this.additionalSubscriptionColumns);
      this.makeWeeks();
    }
    this.setUpform();
    this.dispatchEvents();
    this.loadSubscribers();
    this.setFormValidators();
    this.cd.detectChanges();
  }

  getApiState(){
      const combinedSubscription = combineLatest([
        this.store.pipe(select(getFormsLoading)),
        this.store.pipe(select(getProcessesLoading))
      ]).subscribe(([isFormsLoading, isProcessesLoading]) => {
        this.isFormsLoading = isFormsLoading;
        this.isProcessesLoading = isProcessesLoading;
      });
      this.subsink.add(combinedSubscription);
  }

  dispatchEvents(){
    if(this.datatableTableName === 'Reports'){
      this.store.dispatch(new LoadForms(this.tableId, false));
      this.store.dispatch(new LoadProcesss(this.tableId, false));
    } else if(this.datatableTableName === 'Users'){
      this.store.dispatch(new LoadRoles(this.route.getApplicationKey()));
    } else if(this.datatableTableName === 'Subscriptions'){
      this.store.dispatch(new LoadReports(this.tableId))
    }
  }


  loadSubscribers(){
    if(this.datatableTableName === 'Reports'){
      this.subsink.add(
      combineLatest([
        this.store.pipe(
          select(getForms),
          filter((forms) => !!forms[this.tableId]),
          map((forms) => forms[this.tableId])
        ),
        this.store.pipe(
          select(getProcesses),
          filter((processes)=> !!processes[this.tableId]),
          map((processes)=> processes[this.tableId])
        )
      ]).subscribe(data => {
        this.formOptions = data[0]?.filter(form => form.Type === 'web')?.map(form => ({label:form.Name, value: form.Key}));
        if(!this.fieldObj['related_form']){
          const selectedKey = this.formOptions.find((option:any) => option.label === this.fieldIdToControl('related_form')?.controls?.Value?.value)?.value
          if(selectedKey){
            this.fieldIdToControl('related_form').controls.Value.setValue(selectedKey);
            this.fieldIdToControl('related_form').controls.Value.updateValueAndValidity();
            this.cd.detectChanges();
          }
        }
        this.processOptions = data[1].map(process => ({label:process.Name, value: process.Key}));
        if(!this.fieldObj['related_process']){
          const selectedKey = this.processOptions.find((option:any) => option.label === this.fieldIdToControl('related_process')?.controls?.Value?.value)?.value
          if(selectedKey){
            this.fieldIdToControl('related_process').controls.Value.setValue(selectedKey);
            this.fieldIdToControl('related_process').controls.Value.updateValueAndValidity();
            this.cd.detectChanges();
          }
        }
      }));
    } else if(this.datatableTableName === 'Users'){
      this.subsink.add(
      this.store.pipe(
        select(getAllRoles),
        filter((roles) => !!roles[this.route.getApplicationKey()]),
        map((roles) => roles[this.route.getApplicationKey()])
      ).subscribe(roles => {
        this.roleOptions = roles.map((role:any) => ({ label: role.Name, value: role.Key}))
        if(!this.fieldObj['role']){
          const selectedKey = this.roleOptions.find((option:any) => option.label === this.fieldIdToControl('role')?.controls?.Value?.value)?.value
          if(selectedKey){
            this.fieldIdToControl('role').controls.Value.setValue(selectedKey);
            this.fieldIdToControl('role').controls.Value.updateValueAndValidity();
            this.cd.detectChanges();
          }
        }
      }));
    } else if(this.datatableTableName === 'Subscriptions'){
      this.subsink.add(
      this.store.pipe(
        select(getReports),
        filter((reports) => !!reports[this.tableId]),
        map((reports) => reports[this.tableId])
      ).subscribe(reports => {
        this.options = reports.map(report => ({ label: report.Name, value: report.Key }));
        if(!this.fieldObj['report']){
          const selectedKey = this.options.find((option:any) => option.label === this.fieldIdToControl('report')?.controls?.Value?.value)?.value
          if(selectedKey){
            this.fieldIdToControl('report').controls.Value.setValue(selectedKey);
            this.fieldIdToControl('report').controls.Value.updateValueAndValidity();
            this.cd.detectChanges();
          }
        }
      }));
      if(!this.fieldObj['schedule_hour']){
        const selectedKey = timeOptions.find((option:any) => option.label === this.fieldIdToControl('schedule_hour')?.controls?.Value?.value)?.value
        if(selectedKey){
          this.fieldIdToControl('schedule_hour').controls.Value.setValue(selectedKey);
          this.fieldIdToControl('schedule_hour').controls.Value.updateValueAndValidity();
          this.cd.detectChanges();
        }
      }
    }
  }

  close() {
    this.modal.dismissAll();
  }

  isFormValid() {
    return this.form.invalid || !(this.form.controls.FieldsList as UntypedFormArray).controls.some(control => (control as UntypedFormGroup).controls.IsDisabled.value === true) || (this.datatableTableName === 'Subscriptions' && this.fieldIdToControl('delivery_schedule').value.Value === 'weekly' && !this.subsDaysAsArray.value?.some((day:any) => day?.Status === true))
  }

  updateData = () => {
    this.alert
      .fire(<SweetAlertOptions>{
        ...alertPresets.delete,
        title: 'Are you sure?',
        text: 'This action will update all records with selected values.',
        confirmButtonText: 'Yes, bulk edit',
      })
      .then(async (res: any) => {
        if (res.isConfirmed) {
          this.update()
        }
      });
  };

  update(){
    if(this.datatableTableName === 'Users'){
      if(this.form.value.FieldsList.find((field:any) => field.FieldName === 'active').IsDisabled){
        this.userModalRef = this.modal.open(this.updateActiveTemplate, {
          windowClass: 'modalField-custom modal-custom',
          centered: true,
          backdrop: 'static',
          animation: true,
          keyboard: false,
          size:'lg'
        })
        this.buttonText = this.form.value.FieldsList.find((field:any) => field.FieldName === 'active').Value !== 'false' ? 'Activate' : 'Deactivate'
      } else {
        this.action.dispatch(
          OpTypes.UPDATE,
          new BulkUpdateUsers(this.getUpdatePayload()),
          getUserOperations
        ).then(()=> {
          this.close()
        }).catch(() => {});
      }
    } else if(this.datatableTableName === 'Reports') {
      this.action.dispatch(
        OpTypes.UPDATE,
        new BulkUpdateReports(this.getUpdatePayload()),
        getReportOperations
      ).then(()=> {
        this.close()
      }).catch(() => {});
    } else if( this.datatableTableName === 'Clients'){
      this.action.dispatch(
        OpTypes.UPDATE,
        new BulkUpdateClient(this.getUpdatePayload()),
        getClientsOperations
      ).then(()=> {
        this.close()
      }).catch(() => {});
    } else if(this.datatableTableName === 'Processes') {
      this.action.dispatch(
        OpTypes.UPDATE,
        new BulkUpdateProcess(this.getUpdatePayload()),
        getProcessOperations
      ).then(()=> {
        this.close()
      }).catch(() => {});
    } else if(this.datatableTableName === 'Notifications' || this.datatableTableName === 'Subscriptions' || this.datatableTableName === 'Workflows'){
      this.action.dispatch(
        OpTypes.UPDATE,
        new BulkUpdateNotifications(this.getUpdatePayload()),
        getNotificationOperations
      ).then(()=> {
        this.close()
      }).catch(() => {});
    }
  }

  updateUser(fromAllApps:boolean){
    const userPayload = this.getUpdatePayload();
    this.userModalRef.close();
    userPayload['fromAllApps'] = fromAllApps;
    this.action.dispatch(
      OpTypes.UPDATE,
      new BulkUpdateUsers(userPayload),
      getUserOperations
    ).then(()=> {
      this.close()
    }).catch(() => {});
  }

  getUniqueIdName(){
    if(
      this.datatableTableName === 'Notifications' ||
      this.datatableTableName === 'Subscriptions' ||
      this.datatableTableName === 'Workflows'
    ) {
      return 'notification_key'
    } else if(this.datatableTableName === 'Processes'){
      return 'process_key'
    } else if(this.datatableTableName === 'Clients') {
      return 'clientid'
    } else if(this.datatableTableName === 'Users'){
      return 'id'
    } 
    return 'key';
  }
  getUniqueIdsName(){
    if(this.datatableTableName === 'Clients') {
      return 'ClientIds'
    } else if(this.datatableTableName === 'Users'){
      return 'Ids'
    } 
    return 'Keys';
  }

  getUpdatePayload(){
    const payload:any = {
      [this.getUniqueIdsName()]: this.selectedItems.map(item => item[this.getUniqueIdName()])
    };
    if(this.datatableTableName === 'Users'){
      payload['ApplicationKey'] = this.route.getApplicationKey();
    } else if(this.datatableTableName !== 'Clients'){
      payload['ApplicationTableKey'] = this.tableId;
    }

    const formValues = this.form.value.FieldsList.filter((field:any) => field.IsDisabled);
    formValues.forEach((formValue:any) => {
      if(formValue.FieldName === 'active' && (this.datatableTableName === 'Notifications' || 
        this.datatableTableName === 'Subscriptions' || 
        this.datatableTableName === 'Workflows' || 
        this.datatableTableName === 'Processes')){
          payload['Active'] = formValue.Value;
      }
      const fieldKey = this.columns.find(column => column.FieldName === formValue.FieldName)?.formFieldKey;
      if(fieldKey){
        payload[fieldKey] = formValue.Value;
      }
    })

    if(this.datatableTableName === 'Subscriptions' && this.fieldIdToControl('delivery_schedule').value.Value === 'weekly'){
      let SubscriptionDays = []
      for (let field of this.subsDaysAsArray.value)
        if (field.Status)
          SubscriptionDays.push({
            Day: field.Day,
          });
          payload['SubscriptionDays'] = SubscriptionDays;
    }
    return payload;
  }

  setUpform() {
    this.columns.forEach((f: any) => {
      if(f.IsBulkUpdateAllowed || f.ConditionalBulkUpdate){
        (this.form.controls.FieldsList as UntypedFormArray).push(
          this.fb.group({
            Id:f.FieldName,
            Value:new UntypedFormControl(this.getFieldValue(f)),
            IsDisabled:[false],
            FieldName:f.FieldName,
          })
        )
      }
    });
  }

  setFormValidators(){
    if(this.datatableTableName === 'Reports'){
      this.fieldIdToControl('related_form').controls.Value.setValidators(Validators.required);
      if(this.selectedItems.every(item => item['report_type'] === 'Datatable')){
        this.fieldIdToControl('related_process').controls.Value.setValidators(Validators.required);
        this.fieldIdToControl('related_process').controls.Value.updateValueAndValidity();
      }
    } else if(this.datatableTableName === 'Users') {
      (this.form.controls.FieldsList as UntypedFormArray).controls.forEach(control => {
        (control as UntypedFormGroup).controls.Value.setValidators(Validators.required);
        (control as UntypedFormGroup).controls.Value.updateValueAndValidity();
      });
      if(this.selectedItems.every(item => item['top-level role'] === "Participant")){
        this.fieldIdToControl('role').controls.Value.setValidators(Validators.required);
        this.fieldIdToControl('role').controls.Value.updateValueAndValidity();
      } else {
        this.fieldIdToControl('role').controls.Value.clearValidators();
        this.fieldIdToControl('role').controls.Value.updateValueAndValidity();
      }
    } else if(this.datatableTableName === 'Subscriptions') {
      (this.form.controls.FieldsList as UntypedFormArray).controls.forEach(control => {
        if((control as UntypedFormGroup).value.FieldName !== 'report_format'){
          (control as UntypedFormGroup).controls.Value.setValidators(Validators.required);
          (control as UntypedFormGroup).controls.Value.updateValueAndValidity();
        }
      })
      this.fieldIdToControl('report').controls.IsDisabled?.valueChanges?.subscribe(value => {
        if(!value){
          this.fieldIdToControl('report_format').controls.IsDisabled.setValue(false);
          this.fieldIdToControl('include_link').controls.IsDisabled.setValue(false);
        }
        if(this.fieldIdToControl('report').controls.Value.value && value){
          this.fieldIdToControl('report_format').controls.Value.setValidators(Validators.required);
          this.fieldIdToControl('report_format').controls.Value.updateValueAndValidity();
        }
      })
    } else if(this.datatableTableName === 'Clients') {
      (this.form.controls.FieldsList as UntypedFormArray).controls.forEach(control => {
        (control as UntypedFormGroup).controls.Value.setValidators(Validators.required);
        (control as UntypedFormGroup).controls.Value.updateValueAndValidity();
      })
      this.fieldIdToControl('refreshtokentime').controls.Value.addValidators(Validators.min(1));
      this.fieldIdToControl('refreshtokentime').controls.Value.updateValueAndValidity();
    } else {
      (this.form.controls.FieldsList as UntypedFormArray).controls.forEach(control => {
        (control as UntypedFormGroup).controls.Value.setValidators(Validators.required);
        (control as UntypedFormGroup).controls.Value.updateValueAndValidity();
      })
    }
  }

  getFieldValue(field: any) {
    this.fieldObj[field.FieldName] = false;
    if (this.selectedItems.length > 1) {
      const startIndex = (this.selectedItems[0].colFilter || this.selectedItems[0].colSearch) ? 1:0
      for (let i = startIndex+1; i < this.selectedItems.length; i++) {
        if (
          this.selectedItems[startIndex][field.FieldName] !==
          this.selectedItems[i][field.FieldName]
        ){
          this.fieldObj[field.FieldName]=true;
          return field.FieldType === 'ENUM' || (field.FieldType === 'VARCHAR(255)' && (this.datatableTableName === 'Subscriptions' || this.datatableTableName === 'Users'))
            ? null
            : (field.FieldType === 'TINYINT(1)' || field.FieldType === 'VARCHAR(15)') ? null : '';
        }
      }
      return this.returnValue(field,startIndex);
    } else {
      return this.returnValue(field,0);
    }
  }

  returnValue(field:any,index:any) {
    if(field.FieldType === 'ENUM2'){
      return this.selectedItems[index][field.FieldName]?.split(';')
    } else if(field.FieldType === 'TINYINT(1)'){
      return this.selectedItems[index][field.FieldName] === 'True' ? 'true' : 'false';
    } else if(field.FieldType === 'DATETIME'){
      return moment(this.selectedItems[index][field.FieldName], 'MM-DD-YYYY hh:mm:ss').format('YYYY-MM-DD hh:mm:ss')
    } else if(field.FieldType === 'DATE'){
      return moment(this.selectedItems[index][field.FieldName], 'MM-DD-YYYY').format('YYYY-MM-DD')
    }
    return this.selectedItems[index][field.FieldName];
  }

  inputFieldPlaceholder = (field: any) => {
    switch (field.FieldType) {
      case 'VARCHAR(15)':
        return '(000) 000-0000';
      default:
        this.getFieldValue(field);
        if (this.fieldObj[field.FieldName]===true) {
          return 'Multiple Values';
        }
        return 'Enter here';
    }
  };

  inputTypeSelector = (field: any) => {
    if (field.Values || field.IsExternalOptions) return this.select;

    const type = field.FieldType;

    switch (type) {
      case 'TEXT':
        return this.textarea;
      case 'TINYINT(1)':
        return this.checkbox;
      case 'ENUM':
        return this.select;
      case 'INT':
      case 'VARCHAR(255)':
      case 'VARCHAR':
      default:
        return this.input;
    }
  };

  /**
  * Input field type (number, text etc)
  * @param field
  */
  inputFieldType = (field: any) => {
    if(this.datatableTableName === 'Clients' && field.FieldName === 'refreshtokentime') return 'number';
    switch (field.FieldType) {
      case 'INT':
        return 'number';
      case 'DOUBLE':
        return 'number';
      case 'VARCHAR(255)':
      default:
        return 'text';
    }
  };
  fieldIdToControl = (FieldName: string) => {
    const index = (
      this.form.controls.FieldsList as UntypedFormArray
    ).controls.findIndex((group) => group.value.Id == FieldName);
    return (
      (this.form?.controls.FieldsList as UntypedFormArray).at(index) as UntypedFormGroup
    )
  };

  isColumnUpdateAllowed(col:any) {
    if(col.IsBulkUpdateAllowed){
      return true;
    } else if(col.ConditionalBulkUpdate){
      if(this.datatableTableName === 'Reports' && this.selectedItems.every(item => item.report_type === 'Datatable')){
        return true;
      } else if(this.datatableTableName === 'Users' && this.selectedItems.every(item => item['top-level role'] === 'Participant')){
        return true;
      } if(this.datatableTableName === 'Subscriptions'){
        if(this.fieldIdToControl('report')?.value?.Value){
          return true;
        }
      }
    }
    return false;
  }

  getDropdownValues(col:any) {
    if(this.datatableTableName === 'Reports'){
      if(col.Name.includes('Form')) return this.formOptions;
      else if(col.Name.includes('Process')) return this.processOptions;
    } else if(this.datatableTableName === 'Users') {
      return this.roleOptions;
    } else if(this.datatableTableName === 'Subscriptions'){
      if(col.Name === 'Report') return this.options;
      else if(col.Name.includes('Delivery')) return ['weekly','daily'].map((type) => ({ label: type, value:type}));
      else if(col.Name.includes('Report Format')) return this.reportTypes;
      else if(col.Name.includes('Hour')) return timeOptions;
    }
    return col.dropdownValues || [];
  }

  get subsDaysAsArray() {
    return this.subscriptionDaysArray;
  }

  addWeekday = (day: string | null = null, status: undefined | any) => {
    this.subsDaysAsArray.push(
      this.fb.group({
        Day: [day],
        Status: [!status ? false : true],
      })
    );
  };

  makeWeeks = () => {
    this.subsDaysAsArray.clear();
    this.weekDays.forEach((day) => {
      this.addWeekday(day, undefined);
    });
  };

  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  asFormGroup = (form: any) => form as UntypedFormGroup;
}
